import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/callback`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        setUser(data);
        // Use history.replaceState to clear the hash, then navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Google sign-in failed';
        navigate('/login', { replace: true, state: { error: msg } });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#000e2a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#fbdd68] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#8892b0] text-sm">Signing in with Google...</p>
      </div>
    </div>
  );
}
